import angular from 'angular';

let InsuranceDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Insurance) {
  let $ctrl = this;

  const daysPerYear = 365;
  const monthsPerYear = 30.4167;

  $ctrl.id = $state.params.id;
  $ctrl.isEdit = false;
  $ctrl.insurance;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    onChangeState

  });

  activate();

  function activate() {
    clearForm();
    $ctrl.state_id = null
    Insurance.listStates().then(function (states) {
      $ctrl.states = states;
      loadResource($ctrl.id);
    })
  }

  function onChangeState(stateId) {
    $ctrl.city_id = undefined;
    $ctrl.loadingCities = true;

    Insurance.listCities($ctrl.state_id)
      .then(cities => {
        $ctrl.cities = cities;
        $ctrl.loadingCities = false;
        $ctrl.resources = []
      })
      .catch(err => {
        console.log('err:', err);
        $ctrl.loadingCities = false;
      });
  }

  function clearForm(form) {
    $ctrl.insurance = {
      validade: 90
    };

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(card, event) {
    let confirmMessage = 'card-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Insurance
          .destroy(card)
          .then(response => {
            Toast.success($filter('translate')('card-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('card.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, insurance) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }
    insurance.save = $ctrl.id != null && $ctrl.id !== '';
    save(insurance);
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = 'LOADING';
      const resource = JSON.parse(localStorage.getItem('insurance'));
      $ctrl.isEdit = true;
      $ctrl.insurance = resource;
      console.log($ctrl.insurance.resource)
      $ctrl.uiState = 'COMPLETE';

    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(card) {
    $ctrl.saving = true;

    Insurance
      .save(card)
      .then(response => {
        Toast.success($filter('translate')('insurance-detail-save-success'));
        $ctrl.card = response;
        $ctrl.saving = false;
        $state.go('insurance.list');
      })
      .catch(err => {
        if (typeof err.data == "string") {
          Toast.error($filter('translate')(err.data));
        } else {
          let defaultErrMsg = 'common-server-error';
          let fourONineMsg = 'card-detail-409-error';
          let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
          Toast.error($filter('translate')(message));
        }
        console.log('err:', err);
        $ctrl.saving = false;
      });
  }
}

InsuranceDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Insurance'];

export default InsuranceDetailController;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-detail.controller.js